var _defs, _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFixmanLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 479.16 193.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: #f26961;\n      }\n\n      .cls-4 {\n        fill: #31a0da;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 40.08,
    y1: 78.72,
    x2: 39.95,
    y2: 155.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f26961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#db6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ae7c8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8787a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#6890b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4f97c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3e9cd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#349fd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31a0da"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 15.94,
    y1: 46.69,
    x2: 142.21,
    y2: 46.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31a0da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#369ed6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#4799cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#6291ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8886a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#b97984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f26961"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.95,129.9h-2.84c-1.95,0-3.54,1.58-3.54,3.54v35.74c0,1.96,1.59,3.55,3.54,3.55h2.84c1.96,0,3.54-1.59,3.54-3.55v-35.74c0-1.96-1.58-3.54-3.54-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.27,151.31l11.8-15.76c.79-1.06,.92-2.49,.33-3.67-.59-1.22-1.83-1.99-3.18-1.98h-3.55c-1.11,0-2.16,.53-2.83,1.41l-8.76,11.72-8.77-11.71c-.67-.89-1.72-1.41-2.83-1.43h-3.55c-1.34,0-2.57,.76-3.16,1.97-.6,1.2-.47,2.62,.33,3.69l11.79,15.75-11.8,15.77c-.8,1.06-.93,2.48-.33,3.67,.59,1.22,1.82,1.98,3.17,1.98h3.55c1.11,0,2.16-.53,2.83-1.43l8.77-11.71,8.74,11.69c.67,.91,1.73,1.44,2.85,1.45h3.55c1.35,0,2.58-.76,3.17-1.97,.59-1.2,.47-2.63-.33-3.69l-11.79-15.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.2,129.11c-5.08,.05-9.89,2.23-13.28,6.01-3.39-3.79-8.21-5.96-13.28-6.01-3.13-.01-6.21,.82-8.9,2.4-.66-1-1.77-1.61-2.96-1.61h-2.84c-1.95,0-3.53,1.58-3.54,3.54v35.74c.01,1.96,1.59,3.54,3.54,3.55h2.84c1.96-.01,3.54-1.59,3.54-3.55v-21.09c0-5.09,3.66-9.08,8.33-9.08s8.33,3.99,8.33,9.08v21.09c0,1.96,1.59,3.54,3.54,3.55h2.84c1.96-.01,3.54-1.59,3.54-3.55v-21.09c0-5.09,3.66-9.08,8.33-9.08s8.33,3.99,8.33,9.08v21.09c0,1.96,1.59,3.54,3.54,3.55h2.84c1.96-.01,3.54-1.59,3.54-3.55v-21.09c-.01-10.47-8.2-18.98-18.26-18.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.53,129.9h-2.84c-1.75,0-3.24,1.28-3.5,3.01-3.63-2.42-7.9-3.71-12.25-3.71-12.21,.01-22.12,9.91-22.13,22.13,.01,12.21,9.91,22.11,22.13,22.13,4.36-.01,8.62-1.3,12.25-3.72,.26,1.73,1.75,3,3.5,3h2.83c1.96,0,3.54-1.58,3.55-3.54v-35.74c-.01-1.96-1.59-3.54-3.54-3.54Zm-6.38,21.5c-.07,6.71-5.51,12.11-12.21,12.13-6.74-.01-12.21-5.47-12.21-12.22s5.47-12.2,12.21-12.21c6.7,.01,12.14,5.4,12.21,12.1v.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M301.95,129.11c-3.56,.01-7.05,.95-10.12,2.74-.6-1.19-1.83-1.95-3.16-1.95h-2.84c-1.95,0-3.54,1.58-3.54,3.54v35.74c0,1.96,1.59,3.54,3.54,3.55h2.84c1.96-.01,3.54-1.59,3.54-3.55v-21.09c0-5,4.37-9.08,9.75-9.08s9.76,4.08,9.76,9.08v21.09c0,1.96,1.58,3.54,3.54,3.55h2.83c1.96-.01,3.54-1.59,3.54-3.55v-21.09c0-10.47-8.82-18.98-19.66-18.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M402.05,114.51h-2.84c-1.95,0-3.54,1.58-3.54,3.54v20.61h-27.24v-20.61c0-1.96-1.58-3.54-3.54-3.54h-2.83c-1.96,0-3.54,1.58-3.54,3.54v51.13c0,1.96,1.58,3.54,3.54,3.55h2.83c1.96-.01,3.54-1.59,3.54-3.55v-20.61h27.24v20.61c0,1.96,1.59,3.54,3.54,3.55h2.84c1.96-.01,3.54-1.59,3.54-3.55v-51.13c0-1.96-1.58-3.54-3.54-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M466.03,166.8l-13.94-15.29c7.28-2.92,12.05-9.98,12.04-17.82-.01-10.58-8.58-19.16-19.17-19.17h-22.55c-1.96,0-3.54,1.58-3.54,3.54v51.13c0,1.96,1.58,3.54,3.54,3.54h2.83c1.96,0,3.54-1.58,3.55-3.54v-16.31h6.63c2.96,.01,5.77,1.29,7.73,3.52l13.86,15.2c.67,.73,1.61,1.13,2.59,1.13h3.84c1.41-.01,2.68-.85,3.26-2.14,.54-1.27,.29-2.76-.64-3.78Zm-21.08-23.84h-16.18v-18.53h16.18c5.12,0,9.26,4.15,9.27,9.26-.01,5.13-4.15,9.27-9.27,9.27Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 92.27,
    cy: 86.69,
    r: 19.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.11,49.02v106.87c0,13.25-10.82,24.1-24.07,24.1s-24.1-10.85-24.1-24.1V68.87s19.59-17.35,48.18-19.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M142.21,32.87c0,5.61-2.64,10.71-6.94,14.38-4.26,3.7-10.17,5.98-16.67,5.98h-50.6l-3.89,.16c-38.02,.42-48.18,27.48-48.18,27.48V37.48c0-.78,.06-1.56,.16-2.33-.09-.75-.16-1.5-.16-2.28,0-1.99,.34-3.94,1-5.77,1.12-3.27,3.2-6.23,5.94-8.61,4.29-3.7,10.17-5.98,16.67-5.98H118.6c13,0,23.61,9.18,23.61,20.37Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 479.16,
    height: 193.13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixmanLogo);
export default __webpack_public_path__ + "static/media/fixmanLogo.7aa1bf132251a586eaf3d3a5bb9eba22.svg";
export { ForwardRef as ReactComponent };